import { useQuery } from 'react-query'
import { searchAddresses } from '../../../utils/badaAppointmentApi'

export const useSearchAddress = (
  { searchText, refinementId, limit, countries },
  enabled = true
) =>
  useQuery(
    ['searchAddress', searchText, refinementId, limit, countries],
    () => searchAddresses({ searchText, refinementId, limit, countries }),
    { retry: 2, enabled }
  )
